<template>
  <div :style="'min-width:' + (isMobile ? 'auto' : '1340px')" id="app">
    <div
      :style="'background:' + backgroundColor"
      v-if="!isMobile"
      v-show="showTop"
      class="topNav"
    >
      <img
        @click="goIndex"
        class="logo"
        :src="require('./images/home/logo.png')"
        alt=""
      />

      <div class="rightBtn">
        <span @click="gotoPage" class="register" style="margin-right: 10px"
          >免费体验</span
        >
        <span @click="goAccount" class="register">我的账户</span>
        <el-popover
          placement="bottom"
          transition="el-zoom-in-top"
          width="240"
          trigger="click"
          popper-class="qrCode_father"
        >
          <div class="q_content">
            <div class="top">微仓官方客服账号</div>
            <div class="content">
              <img class="qrcode" src="./images/qrcode.png" alt="" />
              <div class="tips">微信扫码立即咨询</div>
            </div>
          </div>
          <button slot="reference" class="consult">立即咨询</button>
        </el-popover>
      </div>
      <div class="nav">
        <router-link
          class="item"
          v-for="(item, index) in navList"
          :key="index"
          :to="item.path"
        >
          <el-tooltip
            v-if="index >= 2 && index != 6"
            class="item"
            effect="dark"
            content="敬请期待"
            placement="bottom"
          >
            <span> {{ item.name }}</span>
          </el-tooltip>
          <span v-if="index <= 1 || index == 6"> {{ item.name }}</span>
        </router-link>
      </div>
    </div>
    <div
      v-if="isMobile && currentPath != '/qrCode'"
      :style="'background:' + backgroundColor"
      class="topNav"
    >
      <img
        @click="goIndex"
        v-if="showTop"
        class="logo"
        :src="require('./images/home/logo.png')"
        alt=""
      />
      <img
        @click="goIndex"
        v-if="!showTop"
        class="logo"
        :src="require('./images/home/logo1.png')"
        alt=""
      />
      <img
        @click="showNav"
        v-if="showTop"
        class="navImg"
        :src="require('./images/mobile_X5/nav.png')"
        alt=""
      />
      <img
        @click="showNav"
        v-if="!showTop"
        class="navImg"
        :src="require('./images/mobile_X5/nav1.png')"
        alt=""
      />
    </div>
    <mt-popup class="navPopup" v-model="navVisible" position="right">
      <i @click="navVisible = false" class="el-icon-close icon-close"></i>
      <div @touchmove.prevent="mousemove" class="list">
        <div
          @click="goPage(item.path, index)"
          v-for="(item, index) in navList"
          :key="index"
          class="item"
        >
          <el-tooltip
            v-if="index >= 2 && index != 6"
            class="item"
            effect="dark"
            content="敬请期待"
            placement="bottom"
          >
            <span>{{ item.name }}</span>
          </el-tooltip>
          <span v-if="index <= 1 || index == 6"> {{ item.name }}</span>
        </div>

        <!-- <el-tooltip
          class="item"
          effect="dark"
          content="敬请期待"
          placement="bottom"
        > -->
        <div
          @click="handleConsult"
          style="border-bottom: 1px solid #d8d8d8; padding-left: 0.2rem"
          class="item"
        >
          立即咨询
        </div>
        <!-- </el-tooltip> -->
        <div @click="goAccount" class="item">我的账户</div>
      </div>
    </mt-popup>
    <router-view />
  </div>
</template>
<script>
import store from "./store/index";
export default {
  data() {
    return {
      navVisible: false
    };
  },
  computed: {
    navList() {
      return [
        { name: "首页", path: "/" },
        { name: "X5", path: "/X5Details" },
        { name: "DL", path: this.$route.fullPath },
        { name: "DY", path: this.$route.fullPath },
        { name: "DC", path: this.$route.fullPath },
        { name: "EV", path: this.$route.fullPath },
        { name: "微仓+", path: "/weicangPlus" },
        { name: "服务", path: this.$route.fullPath },
        { name: "奕优", path: this.$route.fullPath }
      ];
    },
    currentPath() {
      return this.$route.path;
    },
    showTop() {
      if (store.state.showTop) {
        // store.commit("edit_backgroundColor", "rgba(0, 0, 0, 1)");
      } else {
        store.commit(
          "edit_backgroundColor",
          !this.isMobile ? "rgba(0,0,0,1)" : "#fff"
        );
      }
      return store.state.showTop;
    },
    isMobile() {
      return store.state.isMobile;
    },

    backgroundColor() {
      return store.state.backgroundColor;
    }
  },
  methods: {
    handleConsult() {
      this.navVisible = false;
      if (/MicroMessenger/i.test(window.navigator.userAgent)) {
        window.open("https://work.weixin.qq.com/kfid/kfccaf9816b18773798");
      } else {
        this.$router.push("/qrCode");
      }
    },
    mousemove(e) {
      console.log(e);
    },
    goAccount() {
      if (this.$store.state.user) {
        this.$store.commit("edit_showAccount", true);
        this.$router.push("/orderInfo");
      } else {
        this.$router.push("/login");
      }
      this.navVisible = false;
    },
    goIndex() {
      this.$router.push("/");
    },
    goPage(path, index) {
      if (index <= 1 || index == 6) {
        this.navVisible = false;
        this.$router.push(path);
      }
    },
    gotoPage() {
      let userName = sessionStorage.getItem("user");
      if (userName) {
        console.log(JSON.parse(userName));
        let { mobilePhone, accessToken, mobilePassword } = JSON.parse(userName);
        window.open(
          `${process.env.VUE_APP_PROJECT_URL}?token=${accessToken}&account=${mobilePhone}&password=${mobilePassword}`
        );
        // window.open(
        //   `http://localhost:3000/#/login?token=${accessToken}&account=${mobilePhone}&password=${mobilePassword}`
        // );
      } else {
        this.$router.push({
          path: "/login",
          query: {
            free: true
          }
        });
      }
    },
    showNav() {
      this.navVisible = true;
    },
    judgeMobile() {
      var userAgentInfo = navigator.userAgent;

      var mobileAgents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod"
      ];

      var mobile_flag = false;

      //根据userAgent判断是否是手机
      for (var v = 0; v < mobileAgents.length; v++) {
        if (userAgentInfo.indexOf(mobileAgents[v]) > 0) {
          mobile_flag = true;
          break;
        }
      }
      var screen_width = window.screen.width;
      var screen_height = window.screen.height;

      //根据屏幕分辨率判断是否是手机
      // if (screen_width > 325 && screen_height < 750) {
      //   mobile_flag = true
      // }

      return mobile_flag;
    }
  },
  mounted() {
    var that = this;
    store.commit("edit_screenWidth", document.documentElement.clientWidth);
    store.commit("edit_screenHeight", document.documentElement.clientHeight);
    store.commit("edit_isMobile", that.judgeMobile());
    if (document.documentElement.clientWidth > 800) {
      document.getElementsByTagName("html")[0].style["font-size"] =
        document.documentElement.clientHeight / 40 + "px";
    } else {
      document.getElementsByTagName("html")[0].style["font-size"] = "";
    }
    window.onresize = function() {
      if (document.documentElement.clientWidth > 800) {
        document.getElementsByTagName("html")[0].style["font-size"] =
          document.documentElement.clientHeight / 40 + "px";
      } else {
        document.getElementsByTagName("html")[0].style["font-size"] = "";
      }

      store.commit("edit_screenWidth", document.documentElement.clientWidth);
      store.commit("edit_screenHeight", document.documentElement.clientHeight);
      store.commit("edit_isMobile", that.judgeMobile());
    };
  }
};
</script>
<style lang="less">
.qrCode_father {
  padding: 0 !important;
  border: none !important;
  .q_content {
    .top {
      height: 50px;
      background: #3e3e3e;
      line-height: 50px;
      text-align: center;
      color: #fff;
      font-size: 18px;
      font-weight: normal;
    }
    .content {
      text-align: center;
      padding: 26px 0 32px 0;
      .qrcode {
        width: 174px;
        height: 174px;
        margin: 0 auto 10px;
      }
    }
  }
  .popper__arrow,
  .popper__arrow::after {
    border-bottom-color: #3e3e3e !important;
  }
}

#app {
  min-width: 1366px;
  height: 100%;
  position: relative;
  .navPopup {
    height: 100%;
    width: 6.2rem;
    background-color: #fff;
    z-index: 2;
    padding: 0.4rem;
    .list {
      margin-top: 0.9rem;
      .item {
        display: block;
        height: 1.12rem;
        line-height: 1.12rem;
        border-bottom: 1px solid #d8d8d8;
        padding-left: 0.2rem;
        font-size: 0.24rem;
      }
      .el-tooltip.item {
        border-bottom: none;
        padding: 0;
      }
    }
    .icon-close {
      float: right;
      font-size: 0.42rem;
      opacity: 0.8;
    }
  }
}
.topNav {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: 8px 20px;
  z-index: 999;
  background: rgba(0, 0, 0, 1);

  .logo {
    width: 57px;
    height: 34px;
    float: left;
  }
  .rightBtn {
    float: right;
    .consult {
      background: rgba(216, 216, 216, 0);
      border: 1px solid #ffffff;
      padding: 4px 46px;
      color: #ffffff;
      line-height: 20px;
      margin-left: 40px;
      transform: translate(0, 3px);
      cursor: pointer;
    }
    .register {
      color: #ffffff;
      line-height: 20px;
      cursor: pointer;
      display: inline-block;
      transform: translate(0, 4px);
    }
  }
  .nav {
    text-align: center;
    height: 37px;
    line-height: 37px;
    .item {
      padding: 0 20px;
      color: rgba(255, 255, 255, 0.85);
      cursor: pointer;
    }
    .el-tooltip.item {
      padding: 0;
    }
  }
}
.buyTop {
  background: transparent;
}
#app .navImg {
  float: right;
  width: 0.36rem;
  height: 0.28rem;
  margin-top: 0.16rem;
}
</style>
